module.exports = __webpack_public_path__ + "static/img/technology.c5228fd0.png";